import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { connect } from "react-redux";

import '../../css/simpleprogress.css';

const NavLink = props => (
  <li>
    <Link {...props} />
  </li>
);

class ProgressBar extends Component {

  handleProgressClick(e){
    if (e.target.className === "disabled"){
      e.preventDefault();
    }
  }

  render() {
    let linkStyle1 = "active";
    let linkStyle2 = "disabled";
    let linkStyle3 = "disabled";
    let circleStyle2 = "progresscircle disabled";
    // Hard coded progress bar (need to be able add more steps easier)
    // TODO need to set max Loan Docs dynamically (right now manually set to 4)
    if (this.props.step === 0){
      linkStyle1 = "activehollow";
    } else if (this.props.step >= 2 && this.props.doc < 4){
      linkStyle2 = "activehollow";
      circleStyle2 = "progresscircle";
    } else if (this.props.step >= 2 && this.props.doc >= 4){
      linkStyle2 = "active";
      linkStyle3 = "activehollow";
      circleStyle2 = "progresscircle";
    }

    return (
      <div className="container ptop simpleprogresscontainer">
        <div className="row simpleprogressbars">
          <div className="col-xs-6">
            <progress value={this.props.step} max={2}/>
          </div>
          <div className="col-xs-6">
            <progress value={this.props.doc} max={4}/>
          </div>
        </div>
        <ul className="progressbar">
          <NavLink to="/createaccount" className={linkStyle1}><div className="progresscircle"></div>Account</NavLink>
          <NavLink to="/agreement1" className={linkStyle2} onClick={this.handleProgressClick}><div className={circleStyle2}></div>Agreement</NavLink>
          <NavLink to="/finalstep" className={linkStyle3} onClick={this.handleProgressClick}><div className="progresscircle disabled"></div>Approval</NavLink>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    step: state.FormReducer.step,
    doc: state.FormReducer.doc,
});

export default connect(mapStateToProps)(ProgressBar);



// WEBPACK FOOTER //
// ./src/components/partials/SimpleProgressBar.js